export const formatPriceMixin = {
  methods: {
    $_formatPrice(number) {
      return Intl.NumberFormat('en-US', {
        currency: 'USD'
      }).format(number);
    }
  }
};
